import * as React from 'react'
import {useContext} from 'react'


import {ReactComponent as Visibility} from '../../assets/icons/visibility.svg'
import {ReactComponent as Home} from '../../assets/icons/home.svg'
import {ReactComponent as Help} from '../../assets/icons/help.svg'
import {ReactComponent as BarChart3} from '../../assets/icons/bar_chart_3_bars.svg'
import {ReactComponent as BarChart4} from '../../assets/icons/bar_chart_4_bars.svg'
import {ReactComponent as History} from '../../assets/icons/history.svg'
import {ReactComponent as Merge} from '../../assets/icons/merge.svg'
import {ReactComponent as ShieldPerson} from '../../assets/icons/shield_person.svg'
import {ReactComponent as AddLocation} from '../../assets/icons/add_location.svg'
import {ReactComponent as Minus} from '../../assets/icons/minus.svg'
import {ReactComponent as AdminPanelSettings} from '../../assets/icons/admin_panel_settings.svg'
import {ReactComponent as Stacks} from '../../assets/icons/stacks.svg'
import {ReactComponent as MyLocation} from '../../assets/icons/my_location.svg'
import {ReactComponent as Map} from '../../assets/icons/map.svg'
import {ReactComponent as TwoPerson} from '../../assets/icons/two_person.svg'
import {ReactComponent as Close} from '../../assets/icons/close.svg'
import {ReactComponent as List} from '../../assets/icons/list.svg'
import {ReactComponent as Dashboard} from '../../assets/icons/dashboard.svg'
import {ReactComponent as FileExport} from '../../assets/icons/file_export.svg'
import {ReactComponent as Download} from '../../assets/icons/download.svg'
import {ReactComponent as Settings} from '../../assets/icons/settings.svg'
import {ReactComponent as Cases} from '../../assets/icons/cases.svg'
import {ReactComponent as Edit} from '../../assets/icons/edit.svg'
import {ReactComponent as Key} from '../../assets/icons/key.svg'
import {ReactComponent as Delete} from '../../assets/icons/delete.svg'
import {ReactComponent as HealthCrossFill} from '../../assets/icons/health_cross_fill.svg'
import {ReactComponent as HealthCrossOutline} from '../../assets/icons/health_cross_outline.svg'
import {ReactComponent as UsersManagement} from '../../assets/icons/users_management.svg'
import {ReactComponent as Insurance} from '../../assets/icons/insurance.svg'
import {ReactComponent as Police} from '../../assets/icons/police.svg'
import {ReactComponent as Check} from '../../assets/icons/check.svg'
import {ReactComponent as ArrowBack} from '../../assets/icons/arrow_back.svg'
import {ReactComponent as DateFrom} from '../../assets/icons/date_from.svg'
import {ReactComponent as DateTo} from '../../assets/icons/date_to.svg'
import {ReactComponent as Info} from '../../assets/icons/info.svg'
import {ReactComponent as Road} from '../../assets/icons/road.svg'
import {ReactComponent as Car} from '../../assets/icons/car.svg'
import {ReactComponent as Person} from '../../assets/icons/person.svg'
import {ReactComponent as Save} from '../../assets/icons/save.svg'
import {ReactComponent as Cancel} from '../../assets/icons/cancel.svg'
import {ReactComponent as AddPerson} from '../../assets/icons/add_person.svg'
import {ReactComponent as ArrowCircleRight} from '../../assets/icons/arrow_circle_right.svg'
import {ReactComponent as AddCircle} from '../../assets/icons/add_circle.svg'
import {ReactComponent as ArrowLeft} from '../../assets/icons/arrow_left.svg'
import {ReactComponent as ArrowRight} from '../../assets/icons/arrow_right.svg'
import {ReactComponent as Plus} from '../../assets/icons/plus.svg'
import {ThemeContext} from "../../App";
import {useTheme} from "@mui/material";

const icons = {
    visibility: Visibility,
    home: Home,
    help: Help,
    barChart3: BarChart3,
    barChart4: BarChart4,
    history: History,
    merge: Merge,
    shieldPerson: ShieldPerson,
    addLocation: AddLocation,
    minus: Minus,
    close: Close,
    adminPanelSettings: AdminPanelSettings,
    stacks: Stacks,
    myLocation: MyLocation,
    map: Map,
    twoPerson: TwoPerson,
    list: List,
    dashboard: Dashboard,
    fileExport: FileExport,
    download: Download,
    usersManagement: UsersManagement,
    settings: Settings,
    cases: Cases,
    edit: Edit,
    key: Key,
    delete: Delete,
    healthCrossFill: HealthCrossFill,
    healthCrossOutline: HealthCrossOutline,
    insurance: Insurance,
    police: Police,
    check: Check,
    arrowBack: ArrowBack,
    dateFrom: DateFrom,
    dateTo: DateTo,
    arrowCircleRight: ArrowCircleRight,
    info: Info,
    road: Road,
    car: Car,
    person: Person,
    save:Save,
    addPerson: AddPerson,
    cancel: Cancel,
    addCircle: AddCircle,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    plus: Plus,
}

export default function SvgCustomIcon({name, size = 24, color = null}) {
    const Icon = icons[name]
    const {mode} = useContext(ThemeContext)
    const theme = useTheme()

    const iconColor = color ? color : mode === 'dark' ? '#EDEDED' : theme.palette.newColors.gray;

    if (!Icon) {
        console.warn(`Icon not found: ${name}`)
        return null
    }

    return <Icon width={size} height={size} fill={iconColor}/>
}

